import { render, staticRenderFns } from "./AddToLockerButton.vue?vue&type=template&id=1c7927f4&"
import script from "./AddToLockerButton.vue?vue&type=script&lang=js&"
export * from "./AddToLockerButton.vue?vue&type=script&lang=js&"
import style0 from "./AddToLockerButton.vue?vue&type=style&index=0&id=1c7927f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports